import React, { useEffect, useMemo } from 'react';
import _ from 'lodash';
import ReactSelect from '../../../../common/components/UI/Select/ReactSelect';

const AssignmentSelector = ({
    validAssignments,
    selectedAssignmentId,
    onChange,
    labelText,
    placeholder,
}) => {
    const sortedAssignments = useMemo(
        () => _.sortBy(validAssignments || [], ['assignmentName']),
        [validAssignments],
    );
    const isSingle = sortedAssignments.length === 1;

    useEffect(() => {
        if (isSingle && !selectedAssignmentId) {
            onChange(sortedAssignments[0].assignmentId);
        }
    }, [isSingle, selectedAssignmentId, sortedAssignments, onChange]);

    if (sortedAssignments.length === 0) {
        return null;
    }

    const options = sortedAssignments.map(a => ({
        label: a.assignmentName,
        value: a.assignmentId,
    }));
    const selectedOption = options.find(o => o.value === selectedAssignmentId)
        || (isSingle ? options[0] : null);

    return (
        <ReactSelect
            labelText={labelText}
            placeholder={placeholder}
            value={selectedOption}
            options={options}
            isDisabled={isSingle}
            onChange={(_target, selected) => onChange(selected?.value ?? null)}
        />
    );
};

export default AssignmentSelector;

